import container from "../../../libs/container/container";

const amdTopicsDetailsVideoModule = (function () {
    const name = 'topics-details__video-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicDetailsVideoHeaderInnerCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicDetailsVideoCardContentCls, 'animate__fadeIn', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {
        document.querySelector(view.publicVars.cssId.videoCardVideoElementCls).addEventListener('play', () => {
            if(document.querySelector(view.publicVars.cssId.videoCardVideoElementCls).currentTime < 1) {
                container.trackInteraction('video start', {
                    'pageName': view.publicVars.trackAdd.pageName,
                    'page_name': view.publicVars.trackAdd.pageName,
                    'videostartevent': 1,
                    'subsection': 'topics-detail|video',
                    'content_type': 'video',
                    'content_title': 'topics-detail|video start',
                    'english_name': view.publicVars.trackAdd.videoTitle
                });
            }
        });

        document.querySelector(view.publicVars.cssId.videoCardVideoElementCls).addEventListener('ended', () => {
            container.trackInteraction('video complete', {
                'pageName': view.publicVars.trackAdd.pageName,
                'page_name': view.publicVars.trackAdd.pageName,
                'videocompleteevent': 1,
                'subsection': 'topics-detail|video',
                'content_type': 'video',
                'content_title': 'topics-detail|video complete',
                'english_name': view.publicVars.trackAdd.videoTitle
            });
        });
    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdTopicsDetailsVideoModule;